<template>
    <div>
        <div v-if="loginORannouncement == 'login'" class="login-dialog">
            <!-- 登录/注册 -->
            <div v-if="tabIndex == 0 || tabIndex == 1 || tabIndex == 4" class="flex_div">
                <div class="logo-box">
                    <img class="logo" src="@/assets/images/logo.png" />
                </div>
                <ul class="tab">
                    <li :class="{ active: tabIndex == 1 }" @click="changeLiTab(1)">
                        {{ $t(`loginDialogPage.type_phone_or_email`) }}
                    </li>
                    <li :class="{ active: tabIndex == 0 }" @click="changeLiTab(0)">
                        {{ $t(`loginDialogPage.type_psd`) }}
                    </li>
                    <li :class="{ active: tabIndex == 4 }" @click="tabIndex = 4" style="display:none">
                        {{ $t(`loginDialogPage.type_email`) }}
                    </li>
                </ul>

                <!-- 密码登录 -->
                <div class="form-wrapper" id="password-login" v-show="tabIndex == 0">
                    <div class="form-item">
                        <label>{{ $t(`loginDialogPage.account_number`) }}</label>
                        <div>
                            <input id="tel" class="input" v-model="accountNumber"
                                @input="handleInput(accountNumber, 'acn')"
                                :placeholder="$t(`loginDialogPage.phoneoremail_placeholder`)"
                                @keydown.enter="pwdLogin" />
                        </div>
                    </div>
                    <div class="form-item">
                        <label>{{ $t(`loginDialogPage.psd`) }}</label>
                        <div class="p-r login-password">
                            <input class="input" id="pwd" maxlength="15" :type="pwdPreview ? 'password' : 'text'"
                                v-model="password" @input="handleInput(password, 'psd')"
                                :placeholder="$t(`loginDialogPage.psd_placeholder`)" @keydown.enter="pwdLogin" />
                            <svg class="iconpark-icon" v-if="pwdPreview" @click="pwdPreview = false"
                                id="preview-closed">
                                <use href="#preview-close"></use>
                            </svg>
                            <svg v-else class="iconpark-icon" @click="pwdPreview = true" id="preview-opend">
                                <use href="#preview-open"></use>
                            </svg>
                        </div>
                    </div>
                    <div class="forget-password">
                        <label class="remember-account cursor-pointer" for="remember-account">
                            <input type="checkbox" id="remember-account" v-model="checkboxvalue" />
                            <span>{{ $t(`loginDialogPage.remember`) }}</span>
                        </label>
                        <span class="color-primary cursor-pointer" id="forget-password" @click="clickForget()">
                            {{ $t(`loginDialogPage.forget_psd`) }}
                        </span>
                    </div>
                    <button class="login" id="loginBtn" @click="pwdLogin" @keydown.enter="pwdLogin" v-loading='loading'
                        :disabled="loading">
                        {{ $t(`loginDialogPage.login`) }}
                    </button>
                    <div class="login_img">
                        <img v-if="language == 'zh_CN'" class="wx_chat" src="@/assets/images/weichat.png"
                            @click="checkWXLogin" />
                        <img v-if="isNonWebClientFlag" class="wx_chat" src="@/assets/images/hauwei.png"
                            @click="checkHWLogin" />
                    </div>
                </div>
                <!-- 手机号/邮箱验证码登录 -->
                <div class="form-wrapper" id="sms-login" v-show="tabIndex == 1">
                    <div class="form-item">
                        <label>{{ $t(`loginDialogPage.phoneoremail`) }}</label>
                        <div>
                            <input v-model="mobile" @input="handleInput(mobile, 'mobile')" id="tel2" class="input"
                                :placeholder="$t(`loginDialogPage.phoneoremail_placeholder`)"
                                @keydown.enter="codeLogin" />
                        </div>
                    </div>
                    <div class="form-item">
                        <label>{{ environment == 'test' ?
                            $t(`loginDialogPage.inside_code`) : $t(`loginDialogPage.code`) }}</label>
                        <div class="p-r">
                            <input id="validateCode" v-model="smsCode" @input="handleInput(smsCode, 'smsCode')"
                                class="input verification-code" type="text"
                                :placeholder="$t(`loginDialogPage.code_placeholder`)" maxlength="6"
                                @keydown.enter="codeLogin" />
                            <p class="send-code" v-if="environment != 'test'">
                                <input type="button" id="loginBtn2" @click="sentCode" :value="msgText" />
                            </p>
                        </div>
                    </div>
                    <!-- 无痕验证组件（验证码登录） -->
                    <AliyunCaptcha v-if="tabIndex == 1" ref="captchaSms" :scene-id="captchaSceneId" button="#loginBtn2"
                        @verify="handleCaptchaVerify" @error="handleCaptchaError" />

                    <div style="height: 26px"></div>
                    <button class="login" @click="codeLogin" @keydown.enter="codeLogin" v-loading='loading'
                        :disabled="loading">
                        {{ $t(`loginDialogPage.loginOrRegister`) }}
                    </button>
                    <p class="form-desc"> {{ $t(`loginDialogPage.register_tips`) }}</p>
                    <div class="login_img">
                        <img v-if="language == 'zh_CN'" class="wx_chat" src="@/assets/images/weichat.png"
                            @click="checkWXLogin" />
                        <img v-if="isNonWebClientFlag" class="wx_chat" src="@/assets/images/hauwei.png"
                            @click="checkHWLogin" />
                    </div>

                </div>

                <div class="agreement-policy">
                    <p>
                        <input v-if="isNonWebClientFlag" :class="{ 'breathing': !agreementValue }" type="checkbox"
                            @change="changeagreement" style="margin-top: -2px;" v-model="agreementValue" />
                        {{ $t(`loginDialogPage.confirmation_agreement.text1`) }}
                        <span class="link" @click="goPolicy(1)">
                            {{ $t(`loginDialogPage.confirmation_agreement.agreement1`) }}</span>
                        {{ $t(`loginDialogPage.confirmation_agreement.text2`) }}
                        <span class="link" @click="goPolicy(2)">{{
                            $t(`loginDialogPage.confirmation_agreement.agreement2`) }}</span>
                    </p>
                </div>
            </div>
            <!-- 微信登录 -->
            <div class="forget-password-wrapper" v-show="tabIndex == 5">
                <div class="logo-box">
                    <img class="logo" src="@/assets/images/logo.png" />
                    <!-- <svg class="iconpark-icon-close" id="iconpark-icon-close" @click="closeDialog()">
                        <use href="#c-close"></use>
                    </svg> -->
                </div>
                <div class="title_top">
                    <div class="top_div">
                        <img class="weichat" src="@/assets/images/weichat.png" />
                        <h4>微信登录</h4>
                    </div>
                </div>
                <div class="form-wrapper wx_login" id="password-login" v-loading="loadingLog">
                    <div @mouseleave="hideMask">
                        <img class="code_img" :src="getchatDetail.imageUrl" @mouseenter.stop="debouncedShowMask" />
                        <div class="mask" v-show="isMaskVisible">
                            <el-button type="success" round @click="refreshQrcode">刷新</el-button>
                            <!-- <button ></button> -->
                        </div>
                    </div>
                    <p>请使用手机扫码登录</p>
                    <el-button plain style="margin-top:20px" @click="checkPlan">切换其他登录方式</el-button>

                </div>

                <div class="agreement-policy">
                    <p>
                        <input v-if="isNonWebClientFlag" :class="{ 'breathing': !agreementValue }" type="checkbox"
                            @change="changeagreement" style="margin-top: -2px;" v-model="agreementValue" /> 登录即表示同意<span
                            class="link" @click="goPolicy(1)">用户协议</span>和<span class="link"
                            @click="goPolicy(2)">个人信息保护政策</span>
                    </p>
                </div>
            </div>
            <!-- 绑定手机号 -->
            <div class="forget-password-wrapper" v-show="tabIndex == 6">
                <div class="logo-box">
                    <img class="logo" src="@/assets/images/logo.png" />
                </div>
                <div class="title_top">
                    <div class="login_success">
                        <i class="el-icon-success" style="color:#09CD97;font-size:30px"></i>
                        <h4>登录成功</h4>
                    </div>
                    <p class="cont_p">根据国家法律法规要求，绑定手机号获得更高级的安全保护。同时，您可以直接使用手机号进行多平台登录，方便快捷。</p>

                    <!-- <div class="top_div">
                        <h4 style="font-size:16px">绑定手机号</h4>
                    </div> -->
                </div>
                <div class="form-wrapper" id="sms-login">
                    <div class="form-item">
                        <!-- <label>手机号</label> -->
                        <div>
                            <input v-model="mobile" @input="handleInput(mobile, 'mobile')" id="tel2" class="input"
                                maxlength="11" placeholder="请输入手机号" />
                        </div>
                    </div>
                    <!-- 测试环境 暂时去掉   style="display: none;"-->
                    <div class="form-item">
                        <!-- <label>验证码</label> -->
                        <div class="p-r">
                            <input id="validateCode" v-model="smsCode" @input="handleInput(smsCode, 'smsCode')"
                                class="input verification-code" type="text" placeholder="请输入验证码" maxlength="6" />
                            <p class="send-code">
                                <input type="button" @click="sentCodeBing" :value="msgText" id="send-code" />
                            </p>
                        </div>
                    </div>
                    <!-- 无痕验证组件（绑定手机号） -->
                    <AliyunCaptcha v-if="tabIndex == 6" ref="captchaBind" :scene-id="captchaSceneId" button="#send-code"
                        @verify="handleCaptchaVerify" @error="handleCaptchaError" />
                    <p class="error-text" id="error-code" style="display: none">
                        <svg class="iconpark-icon-error">
                            <use href="#Frame"></use>
                        </svg>
                    </p>
                    <div style="height: 26px"></div>
                    <button class="login" id="loginBing" @click="bindingLogin" @keydown.enter="bindingLogin"
                        v-loading='loading' :disabled="loading">
                        立即绑定
                    </button>
                    <!-- <p class="form-desc">绑定后，您用该手机号也可登录该账号</p> -->
                </div>
                <div class="agreement-policy">
                    <p>
                        <input v-if="isNonWebClientFlag" :class="{ 'breathing': !agreementValue }" type="checkbox"
                            style="margin-top: -2px;" v-model="agreementValue" /> 登录即表示同意<span class="link"
                            @click="goPolicy(1)">用户协议</span>和<span class="link" @click="goPolicy(2)">个人信息保护政策</span>
                    </p>
                </div>
            </div>
            <!-- 收集信息 -->
            <div class="forget-password-wrapper" v-show="tabIndex == 7">
                <div class="msg_div">
                    <div class="right_jump" @click="clickjump">跳过</div>
                    <div class="title_msg">完善信息</div>
                    <div class="tit_tip">为您提供个性化解决方案和教程推荐服务</div>
                    <div class="f0_tit_div">您的行业： </div>
                    <el-radio-group v-model="industry">
                        <el-radio v-for="(item, index) in industryData" :key="index" :label="item" size="medium"
                            border>{{ item }}</el-radio>
                    </el-radio-group>
                    <div class="f0_tit_div">从哪里了解到我们？ </div>
                    <el-radio-group v-model="way">
                        <el-radio v-for="(item, index) in wayData" :key="index" :label="item" size="medium" border>{{
                            item }}</el-radio>
                    </el-radio-group>
                    <button style="margin-top: 30px;" v-if="!industry || !way" class="login no_use" @click="clickUse"
                        @keydown.enter="clickUse" v-loading='loading' :disabled="loading">立即使用 </button>
                    <button style="margin-top: 30px;" v-else class="login" @click="clickUse" @keydown.enter="clickUse"
                        v-loading='loading' :disabled="loading">立即使用 </button>
                </div>
            </div>
            <!-- 身份选择 -->
            <div class="forget-password-wrapper" v-show="tabIndex == 8">
                <div class="logo-box">
                    <img class="logo" src="@/assets/images/logo.png" />
                </div>
                <div class="title_top">
                    <div class="login_success">
                        <h4>选择进入身份</h4>
                    </div>
                    <p class="cont_p">
                        不同身份对应不同的数据与工作空间
                    </p>
                </div>
                <div class="identity-tips">
                    <i class="el-icon-warning" style="color: #D97706; font-size: 16px;"></i>
                    <span>已检测到以下多个身份</span>
                </div>
                <div class="identity-list">
                    <div v-for="(identity, index) in identityList" :key="identity.id" class="identity-item"
                        :class="{ active: selectedIdentity === index }" @click="selectIdentity(index)">
                        <div class="identity-icon">
                            <i v-if="identity.user_identity === 1" class="el-icon-user-solid"
                                style="font-size: 24px; color: #0B9F6E;"></i>
                            <i v-else class="el-icon-office-building" style="font-size: 24px; color: #3B82F6;"></i>
                        </div>
                        <div class="identity-info">
                            <p class="identity-name">{{ identity.name }}</p>
                            <p class="identity-desc">{{ identity.user_identity === 1 ? '个人 AI 工作空间' : '企业 AI 工作空间' }}
                            </p>
                        </div>
                        <el-button class="enter-btn" @click.stop="enterWithIdentity(identity, index)">
                            进入
                        </el-button>
                    </div>
                </div>
                <div class="agreement-policy">
                    <p>
                        登录即表示同意<span class="link" @click="goPolicy(1)">用户协议</span>和
                        <span class="link" @click="goPolicy(2)">个人信息保护政策</span>
                    </p>
                </div>
            </div>
            <!-- 失败弹窗 -->
            <!-- width="route.query.source_login?'90%':500" -->
            <el-dialog title="绑定失败" :visible.sync="bingErrorLog" append-to-body @close="handleCloseError"
                :width='dialogWidth' class="bindDialog">
                <div class="dia_tit">您输入的手机号「{{ mobile }}」已被其他账号绑定，您可以将该手机号从被绑定的账号中解除绑定后再绑定至当前账号中，或将原账号注销。</div>
                <div class="dia_p">
                    温馨提示：解除绑定或账号注销后，您将无法通过手机号登录原账号。
                </div>
                <el-button type="primary" @click="handleCloseError">我知道了</el-button>
                <!-- <button class="login" @click="bindingLogin" @keydown.enter="bindingLogin">
                    我知道了
                </button> -->

                <el-tooltip popper-class="topBar-user-popper" placement="top" effect="light">
                    <div slot="content">
                        <div class="contact-box">
                            <img src="@/assets/images/weChatCode.jpg" class="xImg contact-qr" />
                            <p class="contact-desc">扫码添加客服微信</p>
                            <p class="online-time flex center">在线时间：每日09:00 ~ 18:00</p>
                        </div>
                    </div>
                    <div class="dia_que">
                        遇到问题？联系客服
                    </div>
                </el-tooltip>
            </el-dialog>
            <!-- <el-dialog width="30%" title="内层 Dialog" :visible.sync="bingErrorLog"  append-to-body >
            </el-dialog> -->
            <!-- 忘记密码 -->
            <div class="forget-password-wrapper" v-show="tabIndex == 2">
                <div>
                    <span class="back-login" id="back-login" @click="tabIndex = 0">
                        <svg class="iconpark-icon">
                            <use href="#c-left"></use>
                        </svg>
                        返回登录
                    </span>
                </div>
                <ul class="tab">
                    <li class="active">找回密码</li>
                </ul>
                <div class="form-wrapper" id="retrieve-password">
                    <div class="form-item">
                        <label>手机号/邮箱</label>
                        <div>
                            <input v-model="accountNumber" @input="handleInput(accountNumber, 'acn')" id="tel3"
                                class="input" placeholder="请输入手机号/邮箱" />
                        </div>
                    </div>
                    <div class="form-item">
                        <label>验证码</label>
                        <div class="p-r">
                            <input v-model="forgetCode" @input="handleInput(forgetCode, 'forgetCode')"
                                class="input verification-code" type="text" id="validateCode2" placeholder="请输入验证码"
                                maxlength="6" />
                            <p class="send-code">
                                <input type="button" @click="forgetSentCode" :value="forgetMsgText"
                                    id="forget-send-code" />
                            </p>
                        </div>
                    </div>
                    <!-- 无痕验证组件（忘记密码） -->
                    <AliyunCaptcha v-if="tabIndex == 2" ref="captchaForget" :scene-id="captchaSceneId"
                        button="#forget-send-code" @verify="handleCaptchaVerify" @error="handleCaptchaError" />
                    <div class="form-item">
                        <label>设置新密码</label>
                        <div>
                            <input class="input" type="password" id="resetPassword" v-model="resetPassword"
                                @input="handleInput(resetPassword, 'rsp')" maxlength="15" show-password
                                placeholder="请输入6-15位新密码" />
                        </div>
                    </div>
                    <p class="error-text" id="error-retrieve-password" style="display: none">
                        <svg class="iconpark-icon-error">
                            <use href="#Frame"></use>
                        </svg>
                    </p>
                    <button class="login" id="change-password-btn" @click="forgetPwdLogin">
                        确认登录
                    </button>
                </div>
                <div class="agreement-policy" style="margin-top:30px">
                    <p>
                        <input v-if="isNonWebClientFlag" :class="{ 'breathing': !agreementValue }" type="checkbox"
                            style="margin-top: -2px;" v-model="agreementValue" /> 登录即表示同意<span class="link"
                            @click="goPolicy(1)">用户协议</span>和<span class="link" @click="goPolicy(2)">个人信息保护政策</span>
                    </p>
                </div>

            </div>


        </div>
        <div v-else-if="loginORannouncement == 'announcement'" class="announcement">
            <div class="announcement_title">
                <img class="" src="@/assets/images/order_msg.svg" />
                <p>会员权益升级啦！</p>
            </div>
            <div class="announcement_content">
                <p>从今天起，您的会员权益已全面升级为 「通用积分权益」：</p>
                <p>· 会员有效期不变，原有权益已全部升级为通用积分，并额外赠送您 10% 积分；</p>
                <p>· 积分可用于平台所有功能，后续还将解锁更多功能与福利。</p>
                <p>快去看看您的新积分吧～ <span class="lookPoints" @click="lookPoint()">
                        查看积分
                    </span></p>
            </div>
            <div class="announcement_btn">
                <el-button @click="lookPoinRule()">查看积分规则</el-button>
                <el-button type="primary" @click="iKnow()">我知道了</el-button>
            </div>
        </div>
    </div>
</template>
<script>


import { userLogin, resetPassWord, getWechatQr, scanCodeLogin, getUserInfo, bindingAccount, loginSendCode, mealActivationState, activationMeal, supplementaryState, saveSupplementary, ZW_bindingAccount, loginPopUpWindow, identityVerification, identitySwitching } from "@/api/user.js";
import { getCookie, setCookie, removeCookie } from "@/utils/cookie";
import { checkModbile, validateEmail } from '@/utils/utils'
import AliyunCaptcha from "@/components/aliyunCaptcha/aliyunCaptcha.vue";

import i18n from '../../i18n/index'

import { domainName } from '@/utils/domainName'

let MSGINIT = i18n.t('loginDialogPage.send_code')
let MSGSCUCCESS = "${time}" + i18n.t('loginDialogPage.repeat')
let FORGETMSGSCUCCESS = "${time}" + i18n.t('loginDialogPage.repeat')
const MSGTIME = 30;
export default {
    name: "loginDIalog",
    components: { AliyunCaptcha }, // 添加组件注册
    data() {
        return {
            loginORannouncement: 'login',//判断是展示登录还是上线通知
            language: this.$store.state.language,//多语言
            loading: false,
            status: false,
            resultDialogVisible: false,
            // tabIndex: 1,
            tabIndex: this.$store.state.language == 'zh_CN' ? 5 : 1,
            // tabIndex: 1,

            mobile: "",
            pwdPreview: true,
            accountNumber: "",
            password: "",
            msgText: MSGINIT,
            msgKey: false,
            msgTime: 30,
            forgetMsgText: MSGINIT,
            forgetMsgKey: false,
            forgetMsgTime: 30,
            resetPassword: "",
            smsCode: "",
            forgetMobile: "",
            forgetCode: "",
            name: '',
            company_name: '',
            email: '',
            isValidMobile: true,
            isValidEmail: true,
            loginDisplay: this.$store.state.loginDisplay,//
            getchatDetail: {},
            isMaskVisible: false,
            timeoutId: null,
            bingErrorLog: false,//绑定失败弹窗
            loadingLog: false,
            dialogWidth: null,
            source: '',//来源
            forgetFlag: 1,//忘记密码步骤
            configNewPassword: '',
            environment: '',//当前环境
            industry: '',
            way: '',
            industryData: ['教育培训', '医疗健康', '财务金融', '政府单位', '电商', '互联网', '广告传媒', '人力资源', '制造业', '餐饮酒店', '农业', '其他'],
            wayData: ['小红书', '抖音', '视频号', '百度', '公众号', '朋友推荐', '微博', 'B站', '其他'],
            checkboxvalue: false,
            agreementValue: true,
            isNonWebClientFlag: false,
            // 阿里云验证码配置
            captchaSceneId: '1rz4qfl7', // 替换为你的场景ID
            captchaVerifyParam: null,    // 当前验证码参数
            captchaPromise: null,   // 新增：挂起时用的 Promise 回调
            identityList: [],
            selectedIdentity: 0,
        };
    },
    computed: {
        setLoginDisplay() {
            return this.$store.state.loginDisplay
        },
    },
    watch: {
        setLoginDisplay: function (data) {
            this.loginDisplay = data
            this.init()
            clearTimeout(this.timeoutId);
            setTimeout(() => {
                const captcha = this.getCurrentCaptchaRef();
                if (captcha) {
                    console.log('弹窗显示，开始初始化验证码');
                    captcha.init();
                }
            }, 500); // 延迟 500ms 确保过渡动画完成
            if ((this.loginDisplay || window.jsbridge) && this.language == 'zh_CN') {
                if (getCookie("login_token")) {
                    this.getUserInfoFun()
                } else {
                    this.getchatImg()
                    // this.getUserInfoFun()
                }
            }
            if (this.tabIndex == 6) {
                this.tabIndex = 5
            }
        },
        // 新增：监听身份状态
        '$store.state.userIdentity': function (newIdentity, oldIdentity) {
            if (newIdentity !== null && oldIdentity === null) {
                this.getUserInfoFun();
            } else if (newIdentity === null) {
                this.tabIndex = 8;
            }
        }
    },
    props: {
        display: {
            type: Boolean,
            default: true,
        },
    },
    created() {

        //根据不同路由跳转不同页面
        if (this.isMobile()) {
            // console.log("手机端")
            if (this.$route.query.iframes || this.$route.query.source_login) {
                return
            }
            window.location.replace(domainName.api10 + '/indexview');
            return
        }
        MSGINIT = i18n.t('loginDialogPage.send_code')
        MSGSCUCCESS = "${time}" + i18n.t('loginDialogPage.repeat')
        FORGETMSGSCUCCESS = "${time}" + i18n.t('loginDialogPage.repeat')
        this.$forceUpdate()
        if (this.$route.query.login_token) {
            this.$store.commit("setloginToken", this.$route.query.login_token);
        }

        this.timeoutId = null;
        // 测试环境修改为内部验证码登录  //调试测试环境接口 暂时关闭内部验证码
        // this.environment = location.origin == 'https://betawww.yuankong-ai.com' ? 'test' : location.origin == 'http://localhost:8068' ? 'test' : 'production'
    },
    beforeDestroy() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
        }
        if (this.captchaPromise) {
            this.captchaPromise.reject();
            this.captchaPromise = null;
        }
    },
    async mounted() {
        if (getCookie("login_token") && getCookie("login_token") != 'null' && getCookie("login_token") != null) {
            if (!this.$store.state.userIdentity) {
                // 双 Token 只说明认证成功；身份查询在后台执行，多身份时才展示选择页。
                const canContinue = await this.checkIdentity();
                if (canContinue) {
                    await this.executeAfterLogin();
                }
            } else {
                this.getUserInfoFun();
            }
        } else {
            if ((this.loginDisplay && this.tabIndex == 5) || window.jsbridge || this.$route.query.source_login == 'true') { //官网登录//联想登录//其他合作商从工作台登录嵌套
                this.getchatImg()
            }
        }
        if (window.jsbridge) {
            this.dialogWidth = '400px'
            this.source = 'lenovo'
        } else if (this.$route.query.source_login) {
            this.dialogWidth = '400px'
        } else {
            this.dialogWidth = '600px'
        }
        // 来源判断
        if (window.jsbridge) {
            this.source = 'lenovo'
        } else if (this.$route.query.activation_id) {
            this.source = 'zhihu'
        } else {
            this.source = 'web'
        }
        if (typeof Ce !== 'undefined' && Ce) {
            Ce.antiScreenshots();
            // Ce.deletePersistedUrl();
            this.isNonWebClientFlag = true
            this.tabIndex = 1
            this.agreementValue = false
            console.log('当前是 鸿蒙 浏览器');
        }
    },
    methods: {
        // 验证码验证回调
        handleCaptchaVerify(captchaVerifyParam) {
            // console.log('获取到验证参数:', captchaVerifyParam);
            this.captchaVerifyParam = captchaVerifyParam;
            // 如果有挂起的 Promise，直接 resolve
            if (this.captchaPromise) {
                this.captchaPromise.resolve(captchaVerifyParam);
                this.captchaPromise = null;
            }
        },

        handleCaptchaError(error) {
            this.$message.error('验证初始化失败，请刷新页面重试');
            if (this.captchaPromise) {
                this.captchaPromise.reject(error);
                this.captchaPromise = null;
            }
        },

        // 会员权益升级---查看积分
        lookPoint() {
            window.parent.postMessage("success", "*");
            location.href = domainName.api9 + '/personal?type=1&userStatus=2&excelUserActive=1'
            setTimeout(() => {
                this.$store.commit("setLoginDisplay", false);
            }, 100);

        },
        // 会员权益升级----我知道了
        iKnow() {
            this.$store.commit("setLoginDisplay", false);
            window.parent.postMessage("success", "*");
            location.href = domainName.api9
        },
        // 查看积分规则
        lookPoinRule() {
            this.$store.commit("setLoginDisplay", false);
            this.$router.push({
                name: 'announcementPage',
                query: { type: 'upgrade' }
            })
        },
        // 登录即表示同意
        changeagreement() {
            console.log(this.agreementValue)
            if (this.tabIndex == 5) {
                if (!this.agreementValue) {
                    this.getchatDetail.imageUrl = ''
                    clearTimeout(this.timeoutId);
                } else {
                    this.getchatImg()
                }
            }
        },
        handleInput(value, itms) {
            value = value.replace(/[\u4e00-\u9fa5]/g, '');
            if (itms == 'acn') {
                this.accountNumber = value
            } else if (itms == 'psd') {
                this.password = value
            } else if (itms == 'mobile') {
                this.mobile = value
            } else if (itms == 'smsCode') {
                this.smsCode = value
            } else if (itms == 'forgetCode') {
                this.forgetCode = value
            } else if (itms == 'rsp') {
                this.resetPassword = value
            } else if (itms == 'configpsd') {
                this.configNewPassword = value
            }

        },
        //该方法用于判断是否进入手机端
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag
        },
        getUserInfoFun() {
            if (getCookie("login_token")) {
                getUserInfo({
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    this.$store.commit("setSource", res.data.data.source);
                    if (!res.data.data.mobile && this.language == 'zh_CN') {
                        this.tabIndex = 6
                        clearTimeout(this.timeoutId);
                    }
                });
            }
        },
        init() {
            if (!this.loginDisplay) {
                this.smsCode = ''
            }
            clearTimeout(this.timeoutId);
            // 
        },
        // 切换登录方式
        changeLiTab(value) {
            this.tabIndex = value
            this.captchaVerifyParam = null; // 切换时清空验证码参数
            this.captchaPromise = null; // 切换时清空挂起状态
            if (value == 0) {
                this.accountNumber = localStorage.getItem('account_number');
                this.password = localStorage.getItem('password');
                if (localStorage.getItem('account_number') || localStorage.getItem('password')) {
                    this.checkboxvalue = true
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    const refName = this.tabIndex == 0 ? 'captchaPwd' : 'captchaSms';
                    const captcha = this.$refs[refName];
                    if (captcha) {
                        console.log('tab 切换，重新初始化验证码');
                        captcha.init();
                    }
                }, 300);
            });
        },
        // 领取消息提醒接口
        showMeg() {
            mealActivationState({
                access_token: getCookie("access_token"),
                activation_id: this.$route.query.activation_id,
            }).then((res) => {
                if (typeof Ce !== 'undefined' && Ce) {
                    Ce.disAntiScreenshots();
                }
                if (res.data.data.state) {
                    if (res.data.data.status == 1) {
                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: res.data.data.msg,
                            center: true
                        });
                    } else {
                        this.$message({
                            showClose: true,
                            type: 'error',
                            message: res.data.data.msg,
                            center: true
                        });
                    }

                }

            });
        },
        getchatImg() {
            this.loadingLog = true
            getWechatQr({}).then((res) => {
                this.getchatDetail = res.data.data
                this.loadingLog = false
                this.getChatState()
            });
        },
        getChatState() {
            this.timeoutId = setTimeout(() => {
                scanCodeLogin({
                    scene_str: this.getchatDetail.scene_str,
                    activation_id: this.$route.query.activation_id,
                    source: this.source
                }).then((res) => {
                    clearTimeout(this.timeoutId);
                    if (this.tabIndex == 6) {
                        clearTimeout(this.timeoutId);
                        return
                    }
                    if (!res.data.data.is_login) {
                        this.getChatState()
                    } else {
                        this.$message.success("扫码登录成功！");
                        this.$store.commit("setToken", res.data.data.access_token);
                        activationMeal({
                            access_token: getCookie("access_token"),
                            activation_id: this.$route.query.activation_id,
                        }).then((res) => {
                            this.showMeg()
                        });
                        this.$store.commit("setloginToken", res.data.data.login_token);
                        let loginDatas = res.data.data
                        getUserInfo({
                            access_token: getCookie("access_token"),
                        }).then((res) => {
                            this.$store.commit("setSource", res.data.data.source);
                            this.$store.commit('setUserInfo', JSON.stringify(res.data.data))
                            setCookie('userInfo', JSON.stringify(res.data.data))
                            localStorage.setItem('login_token', getCookie("login_token"))
                            localStorage.setItem('access_token', getCookie("access_token"))
                            if (loginDatas.binding_pop_up == 'true') {
                                this.tabIndex = 6
                                window.parent.postMessage("lxSuccessNoMobile", "*");
                            } else {
                                this.$store.commit("setMobile", res.data.data.mobile);
                                this.supplementaryStateFun()
                            }
                        });
                    }
                });
            }, 2000);
        },
        showMask() {
            this.isMaskVisible = true;
        },
        hideMask() {
            this.isMaskVisible = false;
        },
        refreshQrcode() {
            // 这里可以添加刷新二维码的逻辑
            // 例如，重新生成二维码图片
            this.getchatImg()
        },
        debouncedShowMask() {
            this.showMask();
            this.$nextTick(() => this.$forceUpdate());


        },
        // 切换登录方式
        checkPlan() {
            this.tabIndex = 1
            clearTimeout(this.timeoutId);
            this.$nextTick(() => this.$forceUpdate());
        },
        //鸿蒙
        checkHWLogin() {
            if (!this.agreementValue) {
                this.$message.error("请阅读并勾选底部用户协议和个人信息保护政策");
                return
            } else {
                Ce.yk_hwLogin()
            }

        },
        checkWXLogin() {
            this.tabIndex = 5
            if (!this.agreementValue) {
                this.getchatDetail.imageUrl = ''
                clearTimeout(this.timeoutId);
            } else {
                this.getchatImg()
            }
        },
        handleClose() {
            this.resultDialogVisible = false
        },

        // 点击忘记密码
        clickForget() {
            this.tabIndex = 2;
            this.accountNumber = '';
            this.forgetCode = '';
            this.resetPassword = '';
            this.configNewPassword = ''
        },
        // 中文 忘记密码
        forgetPwdLogin() {
            resetPassWord({
                account_number: this.accountNumber,
                code: this.forgetCode,
                password: this.resetPassword,
                access_token: getCookie("access_token"),
            }).then((res) => {
                this.tabIndex = 2
                this.password = this.resetPassword
                this.pwdLogin()
            });
        },

        // 手机号/邮箱登录
        codeLogin() {
            if (!this.agreementValue) {
                this.$message.error("请阅读并勾选底部用户协议和个人信息保护政策");
                return
            }
            this.loading = true
            this.$nextTick(() => {
                userLogin({
                    account_number: this.mobile,
                    code: this.smsCode,
                    activation_id: this.$route.query.activation_id,
                    source: this.source,
                }).then((res) => {
                    this.$store.commit("setToken", res.data.data.access_token);
                    this.$store.commit("setloginToken", res.data.data.login_token);
                    this.$store.commit("setMobile", this.mobile);
                    this.$message.success("登录成功！");
                    activationMeal({
                        access_token: getCookie("access_token"),
                        activation_id: this.$route.query.activation_id,
                    }).then((res) => {
                        this.showMeg()
                    });
                    this.supplementaryStateFun()
                    this.loading = false
                }).catch(err => {
                    window.parent.postMessage("error", "*");
                    this.status = false
                    this.loading = false
                })
            })

        },
        // 密码登录
        pwdLogin() {
            if (!this.agreementValue) {
                this.$message.error("请阅读并勾选底部用户协议和个人信息保护政策");
                return
            }
            this.loading = true
            this.$nextTick(() => {
                userLogin({
                    account_number: this.accountNumber,
                    password: this.password,
                    activation_id: this.$route.query.activation_id,
                    source: this.source
                }).then((res) => {
                    this.$store.commit("setToken", res.data.data.access_token);
                    this.$store.commit("setloginToken", res.data.data.login_token);
                    this.$store.commit("setMobile", this.accountNumber);
                    this.$message.success("登录成功！");
                    // 密码登录本地存储账号密码 

                    if (this.checkboxvalue) {
                        localStorage.setItem('account_number', this.accountNumber)
                        localStorage.setItem('password', this.password)
                    } else {
                        localStorage.removeItem('account_number');
                        localStorage.removeItem('password');
                    }

                    activationMeal({
                        access_token: getCookie("access_token"),
                        activation_id: this.$route.query.activation_id,
                    }).then((res) => {
                        this.showMeg()
                    });
                    this.supplementaryStateFun()
                    this.loading = false
                }).catch(err => {
                    // this.resultDialogVisible = true
                    window.parent.postMessage("error", "*");
                    // this.$store.commit("setLoginDisplay", false);
                    this.status = false
                    this.loading = false
                })
            })

        },
        // 绑定手机号
        bindingLogin() {
            if (!this.agreementValue) {
                this.$message.error("请阅读并勾选底部用户协议和个人信息保护政策");
                return
            }
            this.loading = true
            this.$nextTick(() => {
                // 知网接口不同
                if (JSON.parse(getCookie('howNet'))) {
                    ZW_bindingAccount({
                        account_number: this.mobile,
                        code: this.smsCode,
                        access_token: getCookie("access_token"),
                    }).then((res) => {
                        if (res.data.code == 0) {
                            this.$message.success("绑定成功！");
                            getUserInfo({
                                access_token: getCookie("access_token"),
                            }).then((res) => {
                                this.$store.commit("setMobile", res.data.data.mobile);
                                this.supplementaryStateFun()

                            });
                            // this.$store.commit("setLoginDisplay", false);
                            this.$store.commit("setloginToken", res.data.data.login_token);
                            this.$store.commit("setMobile", this.mobile);
                            this.loading = false
                        }
                    }).catch(err => {
                        // this.resultDialogVisible = true
                        window.parent.postMessage("error", "*");
                        // this.$store.commit("setLoginDisplay", false);
                        this.status = false
                        this.loading = false
                    })
                    return
                }
                bindingAccount({
                    mobile_phone: this.mobile,
                    code: this.smsCode,
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    if (res.data.code == 0) {
                        this.$message.success("绑定成功！");
                        getUserInfo({
                            access_token: getCookie("access_token"),
                        }).then((res) => {
                            this.$store.commit("setMobile", res.data.data.mobile);
                            this.supplementaryStateFun()
                        });
                        this.$store.commit("setloginToken", res.data.data.login_token);
                        this.$store.commit("setMobile", this.mobile);
                        this.loading = false
                    }
                }).catch(err => {
                    window.parent.postMessage("error", "*");
                    this.status = false
                    this.loading = false
                })
            })

        },
        // 手机号/邮箱 
        async sentCode() {
            if (!this.mobile) {
                this.$message.error("请输入手机号/邮箱");
                return;
            }
            // 没拿到验证参数，挂起等待回调
            if (!this.captchaVerifyParam) {
                try {
                    this.captchaVerifyParam = await new Promise((resolve, reject) => {
                        this.captchaPromise = { resolve, reject };
                    });
                } catch (err) {
                    return; // 验证失败，handleCaptchaError 已经提示了
                }
            }
            if (this.msgKey) return;
            this.timeCacl();
            this.$nextTick(() => {
                loginSendCode({
                    account_number: this.mobile,
                    types: 'login',
                    captcha_verify_param: this.captchaVerifyParam
                }).then((res) => {
                    this.captchaVerifyParam = null;
                }).catch(() => {
                    this.captchaVerifyParam = null;
                });
            })
        },
        // 绑定手机号发送验证码
        async sentCodeBing() {
            if (!this.mobile) {
                this.$message.error("请输入手机号");
                return;
            }
            // 没拿到验证参数，挂起等待回调
            if (!this.captchaVerifyParam) {
                try {
                    this.captchaVerifyParam = await new Promise((resolve, reject) => {
                        this.captchaPromise = { resolve, reject };
                    });
                } catch (err) {
                    return;
                }
            }
            if (this.msgKey) return;
            this.timeCacl();
            this.$nextTick(() => {
                loginSendCode({
                    account_number: this.mobile,
                    types: JSON.parse(getCookie('howNet')) ? 'zhiwang_binding_account_number' : 'bind_mobile_phone',
                    captcha_verify_param: this.captchaVerifyParam
                }).then((res) => {
                    this.captchaVerifyParam = null;
                    if (res.data.code == 10031) {
                        this.bingErrorLog = true
                    }
                }).catch(() => {
                    this.captchaVerifyParam = null;
                });
            })
        },

        // 关闭绑定失败提示弹窗
        handleCloseError() {
            this.bingErrorLog = false

        },

        timeCacl() {
            // 计时避免重复发送
            this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime);
            this.msgKey = true;
            const time = setInterval(() => {
                this.msgTime--;
                this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime);
                if (this.msgTime === 0) {
                    this.msgTime = MSGTIME;
                    this.msgText = MSGINIT;
                    this.msgKey = false;
                    clearInterval(time);
                }
            }, 1000);
        },
        // 忘记密码发送验证码
        async forgetSentCode() {
            if (!this.accountNumber) {
                this.$message.error("请输入手机号/邮箱");
                return;
            }
            // 没拿到验证参数，挂起等待回调
            if (!this.captchaVerifyParam) {
                try {
                    this.captchaVerifyParam = await new Promise((resolve, reject) => {
                        this.captchaPromise = { resolve, reject };
                    });
                } catch (err) {
                    return;
                }
            }
            if (this.forgetMsgKey) return;
            this.forgetTimeCacl();
            loginSendCode({
                account_number: this.accountNumber,
                types: 'changePassword',
                captcha_verify_param: this.captchaVerifyParam
            }).then((res) => {
                this.captchaVerifyParam = null;
            }).catch(() => {
                this.captchaVerifyParam = null;
            });
        },
        forgetTimeCacl() {
            // 计时避免重复发送
            this.forgetMsgText = FORGETMSGSCUCCESS.replace(
                "${time}",
                this.forgetMsgTime
            );
            this.forgetMsgKey = true;
            const time = setInterval(() => {
                this.forgetMsgTime--;
                this.forgetMsgText = FORGETMSGSCUCCESS.replace(
                    "${time}",
                    this.forgetMsgTime
                );
                if (this.forgetMsgTime === 0) {
                    this.forgetMsgTime = MSGTIME;
                    this.forgetMsgText = MSGINIT;
                    this.forgetMsgKey = false;
                    clearInterval(time);
                }
            }, 1000);
        },
        goPolicy(type) {
            if (type == 1) {
                // parent.location.href = location.origin + '/?#/UserAgreement'
                // location.reload()
                // return
                // this.$store.commit("setLoginDisplay", false);
                if (window.jsbridge) {
                    this.$router.push()
                    jsbridge.getLaunchOptions().then(res => {
                        parent.location.href = location.origin + '/UserAgreement'
                        location.reload()
                    })
                } else {
                    parent.location.href = domainName.api8 + "/user-agreement?tab=UserAgreement";
                    // window.open(location.origin + '/?#/UserAgreement')
                }
            } else if (type == 2) {
                if (window.jsbridge) {
                    this.$router.push()
                    jsbridge.getLaunchOptions().then(res => {
                        parent.location.href = location.origin + '/PrivacyAgreement'
                        location.reload()
                    })
                } else {
                    parent.location.href = domainName.api8 + "/user-agreement?tab=PrivacyPolicy";
                    // window.open(location.origin + '/?#/PrivacyAgreement')
                }
            }

        },
        // 上线公告接口
        popUpWindow() {
            let params = {
                popup_type: 'upgrade_points',
                popup_version: '1.0.1',
                action: 'show'
            }
            loginPopUpWindow(params).then((res) => {

                if (res.data.data.popup_status == 1) {
                    // 后台身份校验期间弹窗默认关闭；只有确实需要展示公告时才打开。
                    this.$store.commit("setLoginDisplay", true);
                    this.loginORannouncement = 'announcement'
                } else {
                    this.$store.commit("setLoginDisplay", false);
                    window.parent.postMessage("success", "*");
                    location.href = domainName.api9
                }

            });
        },
        // 跳过
        clickjump() {
            this.popUpWindow()
        },
        // 获取完善用户信息弹窗状态--获取后更新积分
        async supplementaryStateFun() {
            const canContinue = await this.checkIdentity();
            if (canContinue) {
                await this.executeAfterLogin();
            }
            return
            getUserInfo({
                access_token: getCookie("access_token"),
            }).then((res) => {
                this.$store.commit('setUserInfo', JSON.stringify(res.data.data))
                setCookie('userInfo', JSON.stringify(res.data.data))
                if (window.jsbridge) {
                    this.$store.commit("setLoginDisplay", false);
                    window.parent.postMessage("success", "*");
                    return
                } else if (JSON.parse(getCookie("cooperativeInfos")) && JSON.parse(getCookie("cooperativeInfos")).is_cooperative) {
                    this.$store.commit("setLoginDisplay", false);
                    window.parent.postMessage("success", "*");
                    return
                }
                supplementaryState({
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    if (res.data.data.popup_state) {
                        this.tabIndex = 7
                    } else {
                        this.popUpWindow()//上线公告
                    }
                });
            });

        },
        // 立即使用
        clickUse() {
            if (!this.industry || !this.way) {
                this.$message.error("请完善信息后再点击提交！");
                return
            }
            this.loading = true
            this.$nextTick(() => {
                saveSupplementary({
                    industry: this.industry,
                    know_the_source: this.way,
                    source: this.source,
                    access_token: getCookie("access_token"),
                }).then((res) => {
                    this.$message.success("信息完善成功！");
                    this.popUpWindow()
                    // this.$store.commit("setLoginDisplay", false);
                    // window.parent.postMessage("success", "*");
                    // this.loading = false
                }).catch(err => {
                    this.loading = false
                })
            })
        },
        // 选择身份（单选）
        selectIdentity(index) {
            this.selectedIdentity = index;
        },

        resetToWechatLogin() {
            // 业务意图：身份校验失败说明当前凭证不能进入身份选择，清空临时选择状态并回到可重新认证的登录页。
            this.identityList = [];
            this.selectedIdentity = 0;
            this.tabIndex = 5;
            // 当前凭证失效时需要展示常规登录入口，不能让用户停留在无反馈的后台校验状态。
            this.$store.commit("setLoginDisplay", true);
            this.getchatImg();
        },

        // 确认进入某身份
        async enterWithIdentity(identity, index) {
            this.loading = true;
            this.selectedIdentity = index;
            try {
                const switchRes = await identitySwitching({
                    access_token: getCookie("access_token"),
                    id: identity.id
                });
                // 企业身份需要切换 access_token
                if (identity.user_identity == 2) {
                    if (switchRes.data.code === 0 && switchRes.data.data && switchRes.data.data.access_token) {
                        setCookie('access_token', switchRes.data.data.access_token);
                        this.$store.commit('setToken', switchRes.data.data.access_token);
                    } else {
                        throw new Error(switchRes.data.msg || '身份切换失败');
                    }
                }
                this.loading = false;
                await this.executeAfterLogin();
            } catch (error) {
                console.error('身份选择失败:', error);
                this.loading = false;
            }
        },

        // 登录后身份校验：多条身份则弹出选择页
        async checkIdentity() {
            try {
                const res = await identityVerification({
                    access_token: getCookie("access_token"),
                    client_type: 'web'
                }, {
                    skipLoginRedirect: true,
                });

                // 接口字段映射：
                // res.data.code -> 身份校验状态（0：可继续选择；非 0：当前凭证不可用）
                // res.data.data -> identityList（可选择的登录身份列表；空数组表示没有可进入的身份）
                if (res.data.code !== 0) {
                    this.resetToWechatLogin();
                    return false;
                }

                if (res.data.code === 0 && res.data.data && res.data.data.length > 0) {
                    this.identityList = res.data.data;
                    // 仅一条且为个人身份，直接放行
                    if (this.identityList.length == 1 && this.identityList[0].user_identity == 1) {
                        return true;
                    }
                    // 多条身份，展示选择页
                    if (this.identityList.length > 1) {
                        this.tabIndex = 8;
                        this.selectedIdentity = 0;
                        // 只有多个身份需要用户决策，才展示身份选择弹窗。
                        this.$store.commit("setLoginDisplay", true);
                        return false;
                    }
                }
                return true;
            } catch (error) {
                console.error('身份验证失败:', error);
                this.resetToWechatLogin();
                return false;
            }
        },

        // 登录成功后统一执行逻辑（原 supplementaryStateFun 的核心内容）
        async executeAfterLogin() {
            const selectedIdentityItem = this.identityList[this.selectedIdentity] || null;
            const userIdentityValue = selectedIdentityItem?.user_identity || null;
            this.$store.commit('setUserIdentity', userIdentityValue);

            const userInfoRes = await getUserInfo({ access_token: getCookie("access_token") });
            this.$store.commit('setUserInfo', JSON.stringify(userInfoRes.data.data));
            setCookie('userInfo', JSON.stringify(userInfoRes.data.data));

            // 企业身份
            if (userIdentityValue == 2) {
                this.$store.commit("setLoginDisplay", false);
                await this.userIdentitySet();
                return;
            }

            // 鸿蒙或合作商
            if (window.jsbridge || (JSON.parse(getCookie("cooperativeInfos")) && JSON.parse(getCookie("cooperativeInfos")).is_cooperative)) {
                this.$store.commit("setLoginDisplay", false);
                window.parent.postMessage("success", "*");
                return;
            }

            // 普通流程：完善信息 -> 公告
            const res = await supplementaryState({ access_token: getCookie("access_token") });
            if (res.data.data.popup_state) {
                this.tabIndex = 7;
                // 信息补充是登录后的必经交互，后台校验结束后在此打开弹窗。
                this.$store.commit("setLoginDisplay", true);
            } else {
                this.popUpWindow();
            }
        },

        // 企业身份登录后的清理与跳转（如项目内无企业版配置，可只保留清理逻辑）
        async userIdentitySet() {
            localStorage.removeItem('queryParams');
            sessionStorage.removeItem('queryParams');
            removeCookie('queryParams');
            removeCookie('cooperativeInfos');
            // 若项目2存在企业版默认页配置，请取消下方注释并导入对应方法
            // await getEnterpriseConfig();
            // enterprise_default_page_Fun();
        },

        // // 关闭登录弹窗
        // closeDialog() {
        //     this.$store.commit("setLoginDisplay", false);
        // },
    },
};
</script>

<style scoped>
body {
    background: none !important;
}

.msg_div {
    padding: 20px;
    box-sizing: border-box;
}

.msg_div .right_jump {
    text-align: right;
    cursor: pointer;
}

.msg_div .title_msg {
    margin-top: 12px;
    color: #000;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
}

.msg_div .tit_tip {
    text-align: center;
}

.msg_div .f0_tit_div {
    margin-top: 16px;
    color: #000;
}

.msg_div ::v-deep .el-radio-group {
    margin-top: 10px;
}

.msg_div ::v-deep .el-radio {
    font-weight: normal;
}

.msg_div ::v-deep .el-radio.is-bordered {
    margin-right: 6px;
    margin-left: 0 !important;
    width: 95px;
    margin-bottom: 10px;
    text-align: center;
}

.msg_div ::v-deep .el-radio__input {
    display: none;
}

.msg_div ::v-deep .el-radio.is-bordered.is-checked {
    background-color: #35ad84;
    border-color: #35ad84;
    color: #fff !important;
}

.msg_div ::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #fff !important;
}

.no_use {
    background: #fff !important;
    color: #35ad84 !important;
    border: solid 1px #35ad84 !important;
}

.flex_div {
    display: flex;
    flex-direction: column;
    height: 100%;
    border-radius: 30px;
    background: none;
}

.login-dialog .agreement-policy {
    padding-bottom: -10px;
    padding: 0 10px !important;
}

.google_login {
    width: 340px;
    margin: 12px auto 0px;
}

.google_login button {
    display: block;
    color: #000;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #fff;
    border: solid 2px #999;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    font-size: 16px;
    /* display: flex;
  text-align: center;
  vertical-align: middle;
  align-items: center; */
}

.google_login img {
    width: 24px;
    position: relative;
    top: 6px;
    margin-right: 10px;
}

.el-divider--horizontal {
    margin: 24px 0 0;
}

.tit_cont {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    line-height: 16px;
}

.agreement-policy .link {
    cursor: pointer;
}

.login-dialog {
    width: 444px !important;
    height: 560px !important;
    margin: 0 !important;
    background: none;
    border-radius: 30px;

    /* height: 600px; */
}

.loginResultDialog {
    .el-dialog__header {
        padding: 0;
    }

    .el-dialog {
        border-radius: 25px;
        overflow: hidden;
    }
}

.title_top {
    text-align: center;
    width: 444px;
    margin: 0 auto;
    margin-top: 30px;
}

.title_top .top_div {
    align-items: center;
    vertical-align: middle;
}

.title_top img {
    width: 40px;
    height: 40px;
    /* margin: 0 auto; */
}

.title_top .top_div h4 {
    display: inline-block;
    position: relative;
    vertical-align: middle;
    align-items: center;
    top: -15px;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    margin-left: 10px;
}

.title_top .login_success {
    text-align: left;
    margin-left: 50px;
    display: flex;
    align-items: center;
}

.title_top .login_success h4 {
    margin-left: 10px;
    font-size: 18px;
    font-weight: 500;
}

.title_top .cont_p {
    text-align: left;
    width: 340px;
    margin: 0 auto;
    margin-top: 10px;
}

.code_img {
    width: 230px;
}

.wx_login {
    text-align: center;
    position: relative;
    width: auto !important;
}

.mask {
    position: absolute;
    top: 0;
    left: 0%;
    width: 230px;
    height: 62%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
}

.mask button {
    padding: 10px 20px;
    /* background: #007bff; */
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 5px;
}

.mask button:hover {
    /* background: #0056b3; */
}

.login_img {
    display: flex;
    text-align: center;
    justify-content: center;
    margin-bottom: 4px;
}

.login_img .wx_chat {
    width: 38px;
    height: 38px;
    /* margin: 0 auto; */
    /* padding: 0 10px; */
    display: block;
    margin-top: 14px;
    cursor: pointer;
}

.bindDialog ::v-deep .el-dialog {
    border-radius: 10px;
    /* width: 90%; */
}

.bindDialog ::v-deep .el-dialog__body {
    padding-top: 0;
}

.bindDialog .dia_tit {
    font-size: 13px;
}

.bindDialog .dia_p {
    margin-top: 10px;
    color: red;
}

.bindDialog button {
    margin: 0 auto;
    display: block;
    margin-top: 20px;
}

.bindDialog .dia_que {
    margin: 0 auto;
    display: block;
    text-align: center;
    margin-top: 10px;
    color: #999;
    cursor: pointer;
}

.contact-box {
    text-align: center;
    line-height: 1;
    font-size: 13px;
}

.contact-qr {
    width: 156px;
    height: 156px;
    border-radius: 8px;
}

.login-dialog .agreement-policy p {
    display: flex;
    vertical-align: middle;
    align-items: center;
}

.login-dialog .agreement-policy p input {
    margin-right: 4px;
}

/* 呼吸灯动画 */
@keyframes breathe {
    0% {
        opacity: 0.4;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.2);
    }

    100% {
        opacity: 0.4;
        transform: scale(1);
    }
}

/* 只有未勾选时才应用动画 */
input[type="checkbox"].breathing {
    animation: breathe 2s ease-in-out infinite;
}

.announcement {
    padding: 20px;
    box-sizing: border-box;
}

.announcement_title {
    display: flex;
    justify-content: center;
    vertical-align: middle;
    align-items: center;
}

.announcement_title p {
    font-size: 18px;
    color: #000;
    font-weight: 500;
    padding-left: 4px;
}

.announcement_content {
    margin-top: 20px;
}

.announcement_content p {
    margin-bottom: 14px;
    color: #333
}

.announcement_content .lookPoints {
    color: #35ad84;
    cursor: pointer;
}

.announcement_btn {
    margin-top: 20px;
    text-align: center;
}

.announcement_btn button {
    border-radius: 10px
}

.announcement_btn ::v-deep .el-button--default:hover {
    background: #fff;
    color: #666;
    border: solid 1px #ddd
}

.announcement_btn ::v-deep .el-button--primary {
    background: #35ad84;
    color: #fff;
    border: solid 1px #35ad84
}
/* 身份选择页面样式 */
.identity-tips {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 20px;
    background: #FFFBEB;
    border-radius: 8px;
    margin: 20px auto;
    width: 380px;
    color: #D97706;
    font-size: 14px;
}

.identity-tips i {
    font-size: 16px;
}

.identity-list {
    padding: 0 32px;
    margin-top: 20px;
    height: 250px;
    overflow: auto;
}

.identity-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px;
    border: 2px solid #E5E7EB;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 16px;
}

.identity-item:hover {
    border-color: #0B9F6E;
    background: #F0FDF4;
}

.identity-item.active {
    border-color: #0B9F6E;
    background: #F0FDF4;
}

.identity-icon {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F3F4F6;
}

.identity-icon i {
    font-size: 24px;
}

.identity-info {
    flex: 1;
}

.identity-info .identity-name {
    font-size: 16px;
    font-weight: 500;
    color: #1F2937;
    margin: 0 0 4px 0;
}

.identity-info .identity-desc {
    font-size: 14px;
    color: #6B7280;
    margin: 0;
}

.enter-btn {
    background: #0B9F6E;
    border: none;
    color: #fff;
    padding: 8px 24px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
}

.enter-btn:hover {
    background: #059669;
    color: #fff !important
}
</style>
